"use strict";
/// <reference path="irep.js"/>

IREP.missionsBand = (function () {
    var init = function (options) {

    };

    var animate = function () {
        CSSPlugin.defaultTransformPerspective = 600;
        var certificateTimeline = new TimelineLite();
        certificateTimeline
            .set($("#malecharacter_sm, #femalecharacter_sm"), { display: "block" })
            .from($("#malecharacter_sm"), .75, { marginLeft: "-=100px", scale: 0, opacity: 0, transformOrigin: "center bottom", ease: Expo.easeOut })
            .from($("#femalecharacter_sm"), .75, { marginLeft: "+=100px", scale: 0, opacity: 0, transformOrigin: "center bottom", ease: Expo.easeOut }, "-=.5");

    };

    return {
        init: init,
        animate: animate
    };
})();